import { apiFetch, clearAuthToken, setAuthToken } from './client';

export interface AuthUser {
  id: number;
  email?: string;
  nickname?: string;
  isGuest?: boolean;
}

interface LoginData {
  token: string;
  user: AuthUser;
}

interface MeData {
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<AuthUser> {
  const data = await apiFetch<LoginData>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });

  setAuthToken(data.token);
  return data.user;
}

export async function getMe(): Promise<AuthUser | null> {
  try {
    const data = await apiFetch<MeData>('/user/me');
    return data.user;
  } catch (error) {
    if (error instanceof Error && 'status' in error && (error.status === 401 || error.status === 403)) {
      clearAuthToken();
    }
    return null;
  }
}

export function logout() {
  clearAuthToken();
}
